import React, { createContext, useContext } from "react";

/**
 * @typedef {Object} Route
 * @property {string} path
 * @property {boolean} exact
 * @property {import('react').Component} component
 * @property {import('react').Component} layout
 * @property {import('react').Component} error
 * @property {[Route]} routes
 */

/** @type {import('react').Context<[Route]>} */
const RoutesContext = createContext(null);

const RoutesProvider = ({ routes, children }) => (
  <RoutesContext.Provider value={routes}>{children}</RoutesContext.Provider>
);
const useRoutes = () => useContext(RoutesContext);

export { RoutesProvider, useRoutes };
